import React from 'react';
import { addDays, endOfMonth, format, isSameDay, isSameMonth, parseISO, startOfMonth, startOfWeek } from 'date-fns';
import { es } from 'date-fns/locale';
import { Link } from 'react-router-dom';
import type { Audiencia } from '../../types';
import { HOY } from '../../utils/fechas';
import { MarcaGoogle } from '../ui/Google';
const DIAS_SEMANA = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
export function CalendarioMes({
  mes,
  audiencias,
  sincronizados
}: {
  mes: Date;
  audiencias: Audiencia[];
  sincronizados?: Set<string>;
}) {
  const inicio = startOfWeek(startOfMonth(mes), {
    weekStartsOn: 1
  });
  const fin = endOfMonth(mes);
  const semanas: Date[][] = [];
  let cursor = inicio;
  while (cursor <= fin || semanas.length < 5) {
    const semana = Array.from({
      length: 7
    }).map((_, i) => addDays(cursor, i));
    semanas.push(semana);
    cursor = addDays(cursor, 7);
    if (semanas.length >= 6) break;
  }
  return <div data-id="element-163" data-mp="7ys36u136pyr">
      <div className="grid grid-cols-7 border-b border-gris-200 bg-gris-50" data-id="element-164" data-mp="7vxo7i0udxcq">
        {DIAS_SEMANA.map(d => <div key={d} className="px-2 py-2 text-2xs font-semibold uppercase tracking-wide text-gris-500" data-id="element-165" data-mp="39nwlek5wle54">
            {d}
          </div>)}
      </div>
      <div className="grid grid-cols-7" data-id="element-166" data-mp="2vqhpcwl5a846">
        {semanas.flat().map(dia => {
        const delDia = audiencias.filter(a => isSameDay(parseISO(a.fecha), dia)).sort((a, b) => a.hora.localeCompare(b.hora));
        const esHoy = isSameDay(dia, HOY);
        const delMes = isSameMonth(dia, mes);
        return <div key={dia.toISOString()} className={`min-h-[7.5rem] border-b border-r border-gris-200 px-2 py-1.5 ${delMes ? 'bg-white' : 'bg-gris-50/70'}`} data-id="element-167" data-mp="3em7w0x40vsoe">
              <p className={`tabular inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold ${esHoy ? 'bg-marino-800 text-white' : delMes ? 'text-gris-700' : 'text-gris-400'}`} data-id="element-168" data-mp="b47lpbazvb7m">
                {format(dia, 'd')}
              </p>
              <ul className="mt-1 space-y-1" data-id="element-169" data-mp="fwmrns4kik1p">
                {delDia.slice(0, 3).map(a => <li key={a.id} data-id="element-170" data-mp="ay30ndb4ai2h">
                    <Link to={`/expedientes/${a.expedienteId}`} title={`${a.hora} · ${a.titulo} · ${a.lugar}`} className={`flex items-start gap-1 rounded px-1 py-0.5 text-2xs leading-tight transition-colors duration-150 ${a.tipo === 'Audiencia' ? 'bg-marino-50 text-marino-800 hover:bg-marino-100' : 'bg-ambar-50 text-ambar-700 hover:bg-ambar-100'}`} data-id="element-171" data-mp="6udfyyxkckmq">
                      <span className="tabular font-semibold" data-id="element-172" data-mp="3faqfkxta6qje">{a.hora}</span>
                      <span className="line-clamp-2 flex-1" data-id="element-173" data-mp="1uqutosbbib8r">{a.titulo}</span>
                      {sincronizados?.has(a.id) && <MarcaGoogle titulo="Sincronizado con Google Calendar" data-id="element-174" data-mp="1yvknmbmf1fr1" />}
                    </Link>
                  </li>)}
                {delDia.length > 3 && <li className="px-1 text-2xs text-gris-400" data-id="element-175" data-mp="28pb7123oqzzv">+{delDia.length - 3} más</li>}
              </ul>
            </div>;
      })}
      </div>
    </div>;
}